import { Checkbox, FilterPanel, Spinner } from "@gsa/afp-component-library"
import { useEffect, useMemo, useRef } from "react"
import { GET_ASSIGNED_ENGINEERS } from "../queries";
import { useQuery } from "@apollo/client";
import { GET_USERS_BY_ROLE } from "../../../services/data-layer";

export default function AsigneeFilterItem() {
    const { getFilterFromState, setFilters, clearOneFilter } = FilterPanel.useFilterPanel();
    const filter = getFilterFromState('assigned_engineer_id');
    const assigned = useRef([]);

    const { data: assignedEngineersData, loading: loadingAssignedEngineers } = useQuery(GET_ASSIGNED_ENGINEERS, {
        fetchPolicy: 'no-cache',
    });

    const { data: engineerUsersData, loading: loadingEngineerUsers } = useQuery(GET_USERS_BY_ROLE, {
        fetchPolicy: 'no-cache',
        variables: {
            filters: [],
            roleId: [501, 502],
        },
    });

    const assignedEngineersWithUserIds = useMemo(() => {
        if (!assignedEngineersData?.getStandardsVehicleGroupPocs?.rows?.length) {
            return [];
        }

        if (!engineerUsersData?.getUsersByRole?.rows?.length) {
            return [];
        }

        const uniqueAssignedEngineers =
            assignedEngineersData.getStandardsVehicleGroupPocs.rows.reduce(
                (acc, curr) => {
                    if (!acc.find((poc) => poc.email === curr.email)) {
                        acc.push(curr);
                    }
                    return acc;
                },
                [],
            ) || [];

        const engineerUsers = engineerUsersData.getUsersByRole.rows || [];

        return uniqueAssignedEngineers.map((engineer, index) => {
            const userEmail = engineerUsers.find(
                (user) => user.email === engineer.email,
            );
            return {
                ...engineer,
                ...userEmail,
                id: String(userEmail?.id || index),
            };
        }).filter((engineer) => Boolean(engineer.name));
    }, [assignedEngineersData, engineerUsersData]);

    const handleUnassignAll = (e) => {
        if (e.target.checked) {
            assigned.current.push('null');
        } else {
            assigned.current = assigned.current.filter((item) => item !== 'null');
        }

        updateFilter();
    }

    const handleAssignAll = (e) => {
        if (e.target.checked) {
            assigned.current = assignedEngineersWithUserIds.map((engineer) => engineer.id);
        } else {
            assigned.current = assigned.current.filter((item) => item === 'null');
        }

        updateFilter();
    }

    const handleAssignEngineer = (e) => {
        if (e.target.checked) {
            if (!assigned.current.includes(e.target.value)) {
                assigned.current.push(e.target.value);
            }
        } else {
            assigned.current = assigned.current.filter((item) => item !== e.target.value);
        }

        updateFilter();
    }

    const updateFilter = () => {
        filter.value = assigned.current;

        if (filter.value.length === 0) {
            clearOneFilter(filter);
        } else {
            setFilters({
                type: 'setOne',
                filter: { ...filter },
                fetchNewData: true,
            })
        }
    }

    useEffect(() => {
        if (assignedEngineersWithUserIds.lengt === 0) return;
        setFilters({
            type: 'updateOptions',
            filter: {
                ...filter,
                options: assignedEngineersWithUserIds.map((engineer) => ({
                    value: engineer.id,
                    label: engineer.name,
                })).concat([
                    { value: 'null', label: 'Unassigned' },
                ])
            }
        })
    }, [assignedEngineersWithUserIds])

    const allAssigned = assignedEngineersWithUserIds.filter((engineer) => {
        return filter.value?.includes(engineer.id) || false;
    }).length === assignedEngineersWithUserIds.length;

    if (loadingAssignedEngineers || loadingEngineerUsers) {
        return <Spinner />;
    }

    return (
        <>
            <Checkbox
                label='Unassigned'
                data-testid='unAssignedcheckbox'
                onChange={handleUnassignAll}
            />
            <Checkbox
                label='Assigned'
                data-testid='assignedcheckbox'
                onChange={handleAssignAll}
                checked={allAssigned}
            />
            {assignedEngineersWithUserIds.length > 0 && (
                <div style={{ paddingLeft: '1rem' }}>
                    {assignedEngineersWithUserIds.map((engineer) => (
                        <Checkbox
                            key={engineer.id}
                            label={engineer.name}
                            data-testid={`assignedEngineer-${engineer.id}`}
                            value={engineer.id}
                            onChange={handleAssignEngineer}
                            checked={filter.value?.includes(engineer.id) || false}
                        />
                    ))}
                </div>
            )}
        </>
    )
}